import { BalanceCard } from './club.balance.card'

export const ClubSidebarLayout = () => {
  return <BalanceCard />
}
